'use strict';

/* global $ */


import { interfaceName } from './settings';

import { AjaxForm } from './modules/ajax-form';
import { Form } from './modules/ajax-form/form';
import { AjaxHandler } from './modules/ajax-handler';
import { Map } from './modules/map';
import { Goal } from './modules/goal';
import { Responsive } from './modules/responsive';
import { Header } from './modules/header';

class Proj {
	constructor() {
		this.init();
	}
	init() {
		this.interfaceName = interfaceName;
		console.log('[ interfaceName ]', this.interfaceName);

		this.ajaxForm = new AjaxForm();
		this.ajaxHandler = new AjaxHandler();
		this.goal = new Goal({
			goals: [
				{
					selector: '.js-goal__link',
					event: 'click',
					handler: function() {
						$(window).trigger('main:reachGoal', $(this).data());
					}
				}, {
					selector: '.js-goal__form',
					event: 'submit',
					handler: function() {
						$(window).trigger('main:reachGoal', $(this).data());
					}
				}, {
					selector: window,
					event: 'goal ajaxForm:goal',
					handler: function(e, data) {
						$(window).trigger('main:reachGoal', data);
					}
				}
			]
		});

		this.responsive = new Responsive();
        this.header = new Header({selector: '.js-header'});

        this.map = new Map({
            selector: '.js-map',
            behaviors: ['default', 'scrollZoom'],
            controls: ['zoomControl'],
            zoom: 15,
            //icon: '/i/marker-map.png',
        });
	}
}

$(function() {
	window.proj = new Proj();
});
